import { AbstractControl, ValidatorFn } from '@angular/forms';

const publicList = [
  '@aim.',
  '@aol',
  '@att.',
  '@charter',
  '@comcast',
  '@earthlink',
  '@facebook',
  '@free.',
  '@freenet',
  '@gmail',
  '@gmx.',
  '@googlemail',
  '@hotmail',
  '@inbox',
  '@juno.',
  '@laposte',
  '@live.',
  '@mail.',
  '@msn',
  '@optonline',
  '@orange.',
  '@outlook',
  '@qq',
  '@rambler',
  '@rediffmail',
  '@rocketmail',
  '@t-online',
  '@telenet',
  '@verizon',
  '@wanadoo',
  '@web.',
  '@yahoo',
  '@yandex',
  '@ymail'
];

export function validatorPublicDomain(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const isPublicDomain = publicList.some((d) =>
      control.value?.toLowerCase().includes(d)
    );
    return isPublicDomain ? { publicDomain: true } : null;
  };
}
